export const lightGray = "#D3D3D3BB";
export const darkGray = "#212121BB";
